import { render, staticRenderFns } from "./DashboardInbox.vue?vue&type=template&id=4cf3fa6e"
import script from "./DashboardInbox.vue?vue&type=script&lang=ts"
export * from "./DashboardInbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cf3fa6e')) {
      api.createRecord('4cf3fa6e', component.options)
    } else {
      api.reload('4cf3fa6e', component.options)
    }
    module.hot.accept("./DashboardInbox.vue?vue&type=template&id=4cf3fa6e", function () {
      api.rerender('4cf3fa6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/DashboardInbox.vue"
export default component.exports